import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// Landing pública de Kidstenia (programa infantil) — página propia con su identidad visual, ver
// kidstenia-landing.tsx. No confundir con /padres (portal privado por token para las familias ya
// inscritas) ni con /kidstenia (redirect legado hacia /padres, ver kidstenia.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/programa-kidstenia",
  head: () => ({
    meta: seoMeta({
      title: "Kidstenia — Espacio de movimiento y calistenia infantil",
      description: "Kidstenia es un espacio de movimiento y calistenia para niñas y niños de 5 a 15 años que buscan descubrir su fuerza, desarrollar confianza y crecer felices.",
      path: "/programa-kidstenia",
    }),
    links: [canonicalLink("/programa-kidstenia")],
  }),
  component: lazyRouteComponent(() => import("./kidstenia-landing"), "KidsteniaLandingPage"),
});
